






































// vue
import { Component, Vue } from 'vue-property-decorator'

// componnents
import { PageHeader } from '@/components'
import { TableListCostCenter } from '@/components/config'

// services
import { CostCenterService } from '@/services/config'

// utils
import { loading, alerts } from '@/utils'

// models
import { CostCenterForm, CostCenterModel } from '@/models/config'
import { BvModalEvent } from 'bootstrap-vue'

// views
import ModalCreateEditCostCenter from './modalCreateEdit.vue'

const newItem: CostCenterForm = {
  name: '',
  description: '',
  is_active: true
}

@Component({
  name: 'CostOfCentersIndex',
  components: {
    PageHeader,
    TableListCostCenter,
    ModalCreateEditCostCenter
  }
})
export default class CostOfCentersIndex extends Vue {
  showModal = false
  costCenter: CostCenterForm = newItem
  title = 'Centro de Costos'
  actionForm = 'save'
  idItemEdit: number|null = null
  items = [
    {
      text: 'Dashboard'
    },
    {
      text: 'Centro de Costos',
      active: true
    }
  ]

  hideModal (event: BvModalEvent) {
    if (event.trigger !== 'ok') {
      this.showModal = false
    }
  }

  addNew () {
    this.idItemEdit = null
    this.actionForm = 'save'
    this.costCenter = newItem
    this.showModal = true
  }

  editItem (cost: CostCenterModel) {
    this.costCenter = {
      name: cost.name,
      description: cost.description,
      is_active: cost.is_active
    }
    if (cost.id) {
      this.idItemEdit = Number(cost.id)
    }
    this.actionForm = 'update'
    this.showModal = true
  }

  async deleteItem (cost: CostCenterModel) {
    const msg = `Seguro que desea eliminar el centro de costo: ${cost.name}`
    const confirm = await alerts.confirm(msg)
    if (confirm && cost.id) {
      loading('show')
      await CostCenterService.delete(cost.id)
      alerts.success()
      this.tableList.getCostCenterWithPagination()
      loading('hide')
    }
  }

  async changeStatus (info: {id: number; status: boolean}) {
    loading('show')
    try {
      await CostCenterService.changeStatus(info.id, info.status)
      alerts.success()
      this.tableList.getCostCenterWithPagination()
    } catch (e) {
      alerts.error()
    }
    loading('hide')
  }

  get tableList (): Vue & { getCostCenterWithPagination: () => void } {
    return this.$refs.table_list as Vue & { getCostCenterWithPagination: () => void }
  }

  get itemInit (): CostCenterForm {
      return newItem
  }
}
